(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ho-belt-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ho-belt-feature')) {
    customElements.define(
      'ho-belt-feature',
      class HoBeltFeature extends HTMLElement {
        connectedCallback() {
          this.pills = Array.from(this.querySelectorAll('[data-hobf-pick]'));
          this.pills.forEach((pill) => {
            pill.addEventListener('click', () => this.activate(pill.dataset.hobfPick));
          });
          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-hobf-size]')) this.selectVariant(event.target);
          });
          this.onBlockSelect = (event) => {
            const id = event.detail && event.detail.blockId;
            if (id && this.querySelector('[data-hobf-panel="' + id + '"]')) this.activate(id);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        activate(id) {
          this.pills.forEach((pill) => pill.setAttribute('aria-pressed', String(pill.dataset.hobfPick === id)));
          this.querySelectorAll('[data-hobf-panel]').forEach((el) => {
            el.hidden = el.dataset.hobfPanel !== id;
          });
          this.querySelectorAll('[data-hobf-media]').forEach((el) => {
            el.hidden = el.dataset.hobfMedia !== id;
          });
        }

        selectVariant(input) {
          const panel = input.closest('[data-hobf-panel]');
          if (!panel) return;
          const data = input.dataset;
          const available = data.available === 'true';
          const idInput = panel.querySelector('[data-hobf-id]');
          const submit = panel.querySelector('[data-hobf-submit]');
          const label = panel.querySelector('[data-hobf-label]');
          const price = panel.querySelector('[data-hobf-price]');
          const compare = panel.querySelector('[data-hobf-compare]');
          const save = panel.querySelector('[data-hobf-save]');
          const sizeValue = panel.querySelector('[data-hobf-size-value]');

          if (idInput) idInput.value = input.value;
          if (sizeValue) sizeValue.textContent = data.title;
          if (submit) {
            submit.dataset.variantId = input.value;
            submit.disabled = !available;
          }
          if (label) label.textContent = available ? label.dataset.add : label.dataset.sold;
          if (price) price.textContent = data.price;
          if (compare) {
            compare.textContent = data.compare;
            compare.hidden = !data.compare;
          }
          if (save) {
            const value = save.querySelector('[data-hobf-save-value]');
            if (value) value.textContent = data.save;
            save.hidden = data.save === '0';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
